import React from 'react';
import { Link } from 'react-router-dom';

interface AppFooterProps {
  className?: string;
  /** When true, footer sticks to bottom of flex container. When false, flows after content. */
  sticky?: boolean;
}

// eslint-disable-next-line max-lines-per-function
export const AppFooter: React.FC<AppFooterProps> = ({ className = '', sticky = true }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={`bg-muted/30 border-t border-border ${sticky ? 'mt-auto' : ''} ${className}`}
    >
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='py-3'>
          <div
            className='flex flex-wrap items-center justify-center gap-x-4 gap-y-2
              text-sm text-muted-foreground'
          >
            {/* Navigation Items */}
            <Link to='/docs' className='hover:text-foreground transition-colors'>
              User Guides
            </Link>
            <span className='text-muted-foreground/50'>|</span>

            <Link to='/docs/support' className='hover:text-foreground transition-colors'>
              Support
            </Link>
            <span className='text-muted-foreground/50'>|</span>

            <Link to='/docs/getting-started' className='hover:text-foreground transition-colors'>
              Getting Started
            </Link>
            <span className='text-muted-foreground/50'>|</span>

            <Link to='/docs/legal/terms' className='hover:text-foreground transition-colors'>
              Terms of Service
            </Link>
            <span className='text-muted-foreground/50'>|</span>

            <Link to='/docs/legal/privacy' className='hover:text-foreground transition-colors'>
              Privacy Policy
            </Link>
            <span className='text-muted-foreground/50'>|</span>

            <Link
              to='/docs/legal/acceptable-use'
              className='hover:text-foreground transition-colors'
            >
              Acceptable Use
            </Link>
            <span className='text-muted-foreground/50'>|</span>

            {/* Copyright */}
            <span className='text-muted-foreground'>© {currentYear} Kebi AI LLC</span>
            <span className='text-muted-foreground/50'>|</span>

            {/* Proudly built in the USA */}
            <span className='inline-flex items-center gap-1.5 text-muted-foreground'>
              Proudly built in the USA
              <svg
                viewBox='0 0 19 10'
                role='img'
                aria-label='United States flag'
                className='h-3.5 w-auto rounded-[1px] shadow-sm ring-1 ring-black/5'
              >
                <rect width='19' height='10' fill='#fff' />
                {[0, 2, 4, 6, 8, 10, 12].map(i => (
                  <rect key={i} y={(i * 10) / 13} width='19' height={10 / 13} fill='#B22234' />
                ))}
                <rect width='7.6' height={(7 * 10) / 13} fill='#3C3B6E' />
                {[1.05, 2.74, 4.43].map(cy =>
                  [1.1, 2.85, 4.6, 6.35].map(cx => (
                    <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r='0.3' fill='#fff' />
                  ))
                )}
              </svg>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
